Vue.component('ack-hover-slider-image', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-hover-slider-image',
	mounted() {
		this.activeCard = this.showDefaultCard();

		this.startIdleTimer();
	},
	props: {
		hoverImageInfo: {
			// :product-info
			type: Object,
			required: true,
		},
		title: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: '',
		},
		isMobile: {
			type: Boolean,
		},
		currentPage: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			activeCard: 0,
			idleTimeout: null,
			images: [
				{
					link: 'https://ackuretta.com',
					src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/solution-banner-World.jpg?v=1693377976',
					alt: 'splint',
					title: 'Test',
				},
				{
					link: 'https://ackuretta.com',
					src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/solution-banner-World.jpg?v=1693377976',
					alt: 'splint',
					title: 'Test',
				},
				{
					link: 'https://ackuretta.com',
					src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/solution-banner-World.jpg?v=1693377976',
					alt: 'splint',
					title: 'Test',
				},
			],
		};
	},
	methods: {
		handleMouseOver(index) {
			try {
				if (index < 0 || index >= this.images.length) {
					throw new Error('Invalid index for hovered card.');
				}
				this.activeCard = index;
				this.resetIdleTimer();
			} catch (error) {
				console.error('Error in handleMouseOver:', error.message);
			}
		},
		handleMouseLeave() {
			// Optionally, you can reset the activeCard here if needed
		},
		startIdleTimer() {
			this.idleTimeout = setTimeout(this.changeActiveCard, 6000);
		},
		resetIdleTimer() {
			clearTimeout(this.idleTimeout);
			this.startIdleTimer();
		},
		changeActiveCard() {
			this.activeCard = (this.activeCard + 1) % this.images.length;
			this.startIdleTimer();
		},
		showDefaultCard() {
			const defaultCardIndex = {
				'sol-build-platforms-page': 0,
				default: 1,
			};

			return defaultCardIndex.hasOwnProperty(this.currentPage)
				? defaultCardIndex[this.currentPage]
				: defaultCardIndex.default;
		},
	},
	beforeDestroy() {
		clearTimeout(this.idleTimeout);
	},
});
